import { HttpHeaders } from '@angular/common/http';

export class Utils {
  public static calcdate(daydiff: number, sourcedt?: Date): Date {
    let retDt = new Date();
    if (sourcedt) {
      retDt = sourcedt;
    }
    if (daydiff) {
      retDt.setDate(retDt.getDate() - daydiff);
    }
    return retDt;
  }

  public static applyOrderBy(data: any, orderBy: string, field: string, isNumber = false): any {
    let tempPositions = JSON.parse(JSON.stringify(data));
    tempPositions.sort((p1, p2) => {
      const _p1 = p1[field] ? p1[field] : 0;
      const _p2 = p2[field] ? p2[field] : 0;
      if (isNumber) {
        if (orderBy === "ASC") {
          return parseFloat(_p2) - parseFloat(_p1);
        }
        else {
          return parseFloat(_p1) - parseFloat(_p2);
        }
      }
      if (orderBy === "ASC") {
        if (_p1 > _p2) {
          return 1;
        }
        if (_p1 < _p2) {
          return -1;
        }
        return 0;
      } else {
        if (_p1 > _p2) {
          return -1;
        }
        if (_p1 < _p2) {
          return 1;
        }

        return 0;
      }
    });
    return tempPositions;
  }

  public static multiplesort(collection: any, sortBy: any[]) {
    return collection.sort(function (a, b) {
      let i = 0, result = 0;
      while (i < sortBy.length && result === 0) {
        let _a = null;
        let _b = null;
        if (sortBy[i].number) {
          _a = a[sortBy[i].prop] ? a[sortBy[i].prop] : 0;
          _b = b[sortBy[i].prop] ? b[sortBy[i].prop] : 0;
          result = sortBy[i].direction * (parseFloat(_a) - parseFloat(_b));
        } else {
          _a = a[sortBy[i].prop] ? a[sortBy[i].prop].toString() : '';
          _b = b[sortBy[i].prop] ? b[sortBy[i].prop].toString() : '';
          result = sortBy[i].direction * (_a < _b ? -1 : (_a > _b ? 1 : 0));
        }
        i++;
      }
      return result;
    });
  }

  public static getHttpOptions() {
    const JWT = 'Bearer ' + sessionStorage.getItem('msal.idtoken');
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin':'*',
        'content-type': 'application/json',
        'Cache-Control': 'no-cache',
        'RCM-GPT-GUID':this.newGuid()
        //'Authorization': JWT,
      })
    };    
    return httpOptions;
  }

  public static getHttpOptionsformdata() {
    const JWT = 'Bearer ' + sessionStorage.getItem('msal.idtoken');
    const httpOptions = {
      headers: new HttpHeaders({        
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'RCM-GPT-GUID':this.newGuid()
        //'Authorization': JWT,
      })
    };    
    return httpOptions;
  }
  
  public static newGuid() {
    return 'GPTUI-' + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public static newGuidByType(guidType) {
    return guidType +'_' + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }



  public static getTaxStatusDisplayName(taxStatusCode) {
    let taxStatusDisplayName = '';
    if(taxStatusCode){
      switch (taxStatusCode.toLowerCase()) {
        case 'taxable':
          taxStatusDisplayName = 'Taxable';
          break;
        case 'tax-deferred':
          taxStatusDisplayName = 'Tax-Deferred';
          break;
        case 'tax-free':
          case 'tax-exempt':
        case '':
          taxStatusDisplayName = 'Tax Exempt';
          break;
      }
    }
    return taxStatusDisplayName;
  }

   public static calculateAge(dob) {
    let age: number = 0;
    if (dob) {
      const currentYear = new Date().getFullYear();      
      age = Utils.calculateAgeForYear(dob,currentYear);
    }
    return age;
   }

   public static calculateAgeForYear(dob, givenYear) {
    let age: number;
    if (dob && givenYear) {
      const birthYear = new Date(dob).getFullYear();
      age = givenYear - birthYear;      
    }
    return age;
   }

   public static calculateAgeFromYear(dob, yr) {
    let age: number;
    if (yr) {
      //convert date again to type Date
      const yearDate = new Date(yr);
      const bdate = new Date(dob);
      const timeDiff = Math.abs(yearDate.getTime() - bdate.getTime() );
      age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
    return age;
   }

   public static converToDollarFormat(num){
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });    
    //console.log(num + ": " + formatter.format(num));
    
    return formatter.format(num);
  }

  public static getRetirementYear(clientAge, retAge){
    let currentYear = new Date().getFullYear();
    let diff = retAge - clientAge;
    let retYear = currentYear + diff;
    return retYear;
  }

  public static getYearByAge(clientCurrentAge, age){
    let currentYear = new Date().getFullYear();
    let diff = age - clientCurrentAge;
    let year = currentYear + diff;
    return year;
  }

  
  public static getCurrency(field): string{
    let curNum: string;
    if(field){
      curNum = field.replace(/\D/g,'').replace(/^0+/,'');
    }
    return curNum;
  }

  public static getNumber(field): number{
    let num: number;
    if(field){
      num = field.replace(/[^\d.-]/g, '');
    }
    return num;
  }


  // public static calculateAge_old(dob) {
  //   let age: number;
  //   if (dob) {
  //     //convert date again to type Date
  //     const bdate = new Date(dob);
  //     const timeDiff = Math.abs(Date.now() - bdate.getTime() );
  //     age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  //   }
  //   return age;
  //  }

   
  //  public static calculateCurrentAge_old(dob, yr) {
  //   let age: number;
  //   if (yr) {
  //     //convert date again to type Date
  //     const yearDate = new Date(Date.UTC(Number(yr), 0, 1));
  //     const bdate = new Date(dob);
  //     const timeDiff = Math.abs(yearDate.getTime() - bdate.getTime() );
  //     age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
  //   }
  //   return age;
  //  }

  public static getDefaultChartOptions(xAxisLabel, yAxisLabel){
    let options = {
      chart: {
        //type: 'area',
        style: {
          fontSize: '18'
        } 
      },
      title: {
          text: ''
      },
      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      xAxis: {
        title: {              
          text: xAxisLabel,
          style: {
            fontSize: '16'
          }
        },
        labels: {
          style: {            
              fontSize:'16'
          }
        },
        type: 'datetime',
        startOnTick: true,
        tickInterval: 1000 * 60 * 60 * 24 * 1825,          
      },
      yAxis: {
        title: {
          text: yAxisLabel,
          style: {
            fontSize: '16'
          }
        },          
        labels: {
          style: {                
              fontSize: '16'
          }
        },
        lineWidth: 0,        
        allowDecimals: false,        
      },
      legend: {
        enabled: true, 
        itemStyle:{
          fontSize: '14'
        }      
      },
      tooltip: {
        shared:true,
        useHTML: true,
        style:{
          color: '4F528C', 
          fontSize: '14',
          fontFamily: 'Avenir',
          fontWeight: 'bold'
        },
        formatter: null,
      },
      plotOptions: {
        area: {
          stacking: 'normal',
          dataLabels: {
            enabled: false
          }          
        },
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false
          }
        },
        series: {
          stickyTracking: true,
          states: {
            inactive: {
                opacity: 1
            }
          }
        }        
      },
      series: []
    };
    return options;
  }

  public static getDefaultSankeyChartOptions(){
    let options = {      
      title: {
          text: ''
      },     
      credits: {
        enabled: false
      },   
      series: []
    };
    return options;
  }


}
